import Rpc from '@/config/apiServer/chain33rpc'
import Store from '../store/index'
import { reactive, computed, ComputedRef } from 'vue'
import { checkIsMobile } from '@/utils/checkDevice'
import { txList } from '@/config/apiServer/esdb'

interface MixinsType {
  block: BlockType,
  txLists: TxType,
  maxHeight: ComputedRef,
  getLastBlock: () => void,
  checkNewBlock: () => void,
  getTxList: () => Promise<void>
}
interface BlockType {
  list: {
    height: number,
    blockTime: number,
    txCount: number,
    hash: string,
    [propName: string]: number | string;
  }[]
}
interface TxType {
  list: {
    from: string,
    blockTime: number,
    to: string,
    hash: string,
    [propName: string]: number | string;
  }[]
}

export default function (): MixinsType {
  const maxHeight = computed<number>(() => Store.state.maxHeight)
  const ListLength: number = checkIsMobile() ? 4 : 10
  const block = reactive<BlockType>({
    list: new Array(ListLength).fill({
      height: '',
      hash: '',
      txCount: '',
      blockTime: ''
    })
  })
  const txLists = reactive<TxType>({
    list: new Array(ListLength).fill({
      hash: '',
      from: '',
      to: '',
      block_time: ''
    })
  })
  const params = [{
    "sort": [{
      "key": "height",
      "ascending": false
    }],
    "page": {
      "number": 1,
      "size": ListLength
    }
  }]

  // 获取最新高度
  function getLastBlock(): void {
    Rpc.getLastHeader().then(data => {
      if (data.error == null && data.result.height != maxHeight.value) {
        Store.updateMaxHeight(data.result.height)
      }
    })
  }
  // 获取区块数据
  async function getBlocks(start: number, end: number): Promise<void> {
    const res = await Rpc.getHeaders(start, end, true)
    if (res.error === null) block.list = res.result.items.reverse()
  }
  // 校验最新高度
  function checkNewBlock(): void {
    const end = maxHeight.value
    const start = end - ListLength + 1 > 0 ? end - ListLength + 1 : 0
    getBlocks(start, end)
  }
  // 获取最新交易
  async function getTxList(): Promise<void> {
    const res = await txList(params)
    if (res.error === null) txLists.list = res.result
  }

  return { block, txLists, maxHeight, getLastBlock, checkNewBlock, getTxList }
}